import React, { useContext, useCallback, useState, useEffect, useMemo } from 'react';
import { makeStyles, useTheme } from '@mui/styles';

import { get as _get } from 'lodash';

import PropTypes from 'prop-types';
import ReactHtmlParser from 'html-react-parser';
import Moment from 'moment';

import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import PopupMenu from '../../../components/popupmenu';
import FilterSearchCombo from '../../../components/filter/filter-search-combo';
import { BTJobSelector } from '../../../components/bt-jobs';
import Tooltip from '../../../components/styled/tooltip';
import DateTimePicker from '../../../components/styled/datetimepicker';

import DataContext from '../../../data/data-context';

const MC2CHECK = process.env.BRICATA_APPLIANCE_TYPE === 'mc2';

const useStyles = makeStyles(theme => ({
    root: {
    },
    nowrap: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    englishtooltip: {
        maxWidth: 500,
    },
    english: {
        position: 'relative',
        '& div': {
            display: 'block',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            fontSize: 'small',
            color: theme.palette.tertiary.main,
            position: 'absolute',
            top: 5,
            left: 10,
            width: '95%',
        }
    },
    stealRoom: {
        paddingLeft: 13,
        paddingRight: 13,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        minWidth: 60,
    },
    datePicker: {
        maxWidth: 162,
    },
}));

const BTMODE_NONE = 0;
const BTMODE_BT = 1;
const BTMODE_LIVE = 2;

const QUICK_JOB = 'job';
const QUICK_WEEK = 'week';
const QUICK_DAY = 'day';
const QUICK_HOUR = 'hour';

const QUICK_FILTERS = [
    { key: QUICK_JOB, title: 'Job Range' },
    { key: QUICK_WEEK, title: 'Last Week' },
    { key: QUICK_DAY, title: 'Last Day' },
    { key: QUICK_HOUR, title: 'Last Hour' },
];

const FilterBar = ({
    hideFilterbar,
    gHideFilterbar,
    hideTimelinebar,
    handleSearchFilterChange,
    showFilterTimeout,
    filter,
    search,
    savedFilters,
    setShowFilter,
    showFilter,
    fields,
    perms,
    handleSelectSavedFilter,
    handleUpsertSavedFilter,
    handleDeleteSavedFilter,
    handleOnFilterExport,
    handleOnFilterImport,
    backtesting,
    handleSetBacktesting,
    handleBacktestingJobsUpdated,
    selectedBTJobs,
    handleSelectBTJobs,
    english,
    toggleFilterbar,
    handleOnQuickFilter,
    handleStartChange,
    handleEndChange,
    quick,
    start,
    end,
    label,
}) => {
    const classes = useStyles();
    const theme = useTheme();

    const [showBacktesting, setShowBacktesting] = useState(false);
    const [quickTitle, setQuickTitle] = useState();
    const [quickFilters, setQuickFilters] = useState(QUICK_FILTERS);
    const [prevQuick, setPrevQuick] = useState(quick);
    const [prevStart, setPrevStart] = useState(start);
    const [prevEnd, setPrevEnd] = useState(end);
    const [prevJobs, setPrevJobs] = useState(selectedBTJobs);
    const { systemSettings } = useContext(DataContext);

    const rangeStart = useMemo(() => Moment(start), [start]);
    const rangeEnd = useMemo(() => Moment(end), [end]);

    const onQuickFilter = useCallback(v => {
        handleOnQuickFilter(v);
    }, [handleOnQuickFilter]);

    const onSelectJobs = useCallback(v => {
        setPrevJobs(v);
        handleSelectBTJobs(v);
    }, [handleSelectBTJobs]);

    const setBacktestingOn = useCallback(() => {
        handleSetBacktesting(BTMODE_BT, prevQuick, prevJobs, [prevStart, prevEnd]);
    }, [handleSetBacktesting, prevQuick, prevJobs, prevStart, prevEnd]);

    const setBacktestingOff = useCallback(() => {
        handleSetBacktesting(BTMODE_LIVE, prevQuick, prevJobs, [prevStart, prevEnd]);
    }, [handleSetBacktesting, prevQuick, prevJobs, prevStart, prevEnd]);

    useEffect(() => {
        setShowBacktesting(_get(systemSettings, 'support.backtesting.ui', false));
    }, [systemSettings]);

    useEffect(() => {
        const qfs = QUICK_FILTERS.filter(f =>
            (backtesting === BTMODE_BT ? f.key === 'job' : f.key !== 'job'));
        const qf = qfs.find(q => q.key === quick);

        setQuickFilters(qfs);
        setQuickTitle(quick ? qf ? qf.title : 'Date Range' : 'Date Range');
        setPrevQuick(current => backtesting === BTMODE_BT ? current : quick);
        setPrevStart(current => backtesting === BTMODE_BT ? current : start);
        setPrevEnd(current => backtesting === BTMODE_BT ? current : end);
    }, [quick, backtesting, start, end]);

    useEffect(() => {
        handleBacktestingJobsUpdated();
    }, [handleBacktestingJobsUpdated]);

    return (
        <Collapse
            in={!hideFilterbar && !gHideFilterbar}
            style={{
                marginLeft: -10,
                paddingBottom: !hideFilterbar ? 10 : 0,
                marginBottom: hideTimelinebar && !hideFilterbar ? 25
                    : MC2CHECK && !hideFilterbar ? 18 : 0,
                display: gHideFilterbar ? 'hide' : '',
            }}>
            {/* gridinitis */}
            <Grid container
                spacing={1} direction="row" justifyContent="space-between" wrap="nowrap">
                <Grid item >
                    <Grid container direction="row" justifyContent="flex-start" wrap="nowrap">
                        {/* filter-search get the surplus room */}
                        <Grid item>
                            <FilterSearchCombo
                                onChange={handleSearchFilterChange}
                                onShow={setShowFilter}
                                show={showFilter}
                                showTimeout={showFilterTimeout}
                                fields={fields}
                                searchPlaceholder={`search ${label}`}
                                filter={filter}
                                search={search}
                                savedFilters={savedFilters}
                                onSelectSavedFilter={handleSelectSavedFilter}
                                onDeleteSavedFilter={perms.delete ? handleDeleteSavedFilter : undefined}
                                onUpdateSavedFilter={perms.write ? handleUpsertSavedFilter : undefined}
                                onNewSavedFilter={perms.write ? handleUpsertSavedFilter : undefined}
                                onFilterExport={handleOnFilterExport}
                                onFilterImport={handleOnFilterImport}/>
                        </Grid>
                        {/* backtesting controls get pulled left and expands just to needs */}
                        <Grid item xs="auto">
                            {!MC2CHECK && showBacktesting &&
                                <Grid container
                                    spacing={1}
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="flex-end"
                                    wrap="nowrap"
                                    style={{ paddingTop: 0, paddingLeft: 15, paddingBottom: 5, height: 48, marginTop: 0 }}>
                                    <Grid item>
                                        <RadioGroup row
                                            style={{ flexWrap: 'nowrap', overflow: 'visible' }}
                                            className={classes.nowrap}>
                                            <FormControlLabel value={BTMODE_LIVE}
                                                control={<Radio
                                                    checked={backtesting === BTMODE_LIVE}
                                                    onChange={setBacktestingOff}
                                                    value={BTMODE_LIVE}
                                                    size="small"
                                                    inputProps={{ 'aria-label': 'Live Alerts' }}/>}
                                                label={`Live ${label}`}
                                                className={classes.nowrap}/>
                                            <FormControlLabel value={BTMODE_BT}
                                                control={<Radio
                                                    checked={backtesting === BTMODE_BT}
                                                    onChange={setBacktestingOn}
                                                    value={BTMODE_BT}
                                                    size="small"
                                                    inputProps={{ 'aria-label': 'Backtesting' }}/>}
                                                label="Backtesting"
                                                className={classes.nowrap} />
                                        </RadioGroup>
                                    </Grid>
                                    {backtesting === BTMODE_BT &&
                                        <Grid item
                                            style={{ paddingLeft: 0 }}>
                                            <BTJobSelector
                                                selection={selectedBTJobs}
                                                onSelect={onSelectJobs}/>
                                        </Grid>}
                                </Grid>}
                        </Grid>
                    </Grid>
                    {/* english filter is displayed below the filter */}
                    <Tooltip
                        className={classes.englishtooltip}
                        title={
                            <React.Fragment>
                                {english ? ReactHtmlParser(english) : ''}
                            </React.Fragment>
                        }
                        placement="bottom-start">
                        <div className={classes.english}>
                            <div>
                                {ReactHtmlParser(english)}
                            </div>
                        </div>
                    </Tooltip>
                </Grid>
                {/* time range controls get pulled right and squeezed to an inch of their lives*/}
                <Grid item style={{ paddingTop: 0 }} className={classes.nowrap}>
                    <Grid container spacing={2} direction="row" justifyContent="flex-end" alignItems="flex-end" wrap="nowrap">
                        <Grid item>
                            {/* quick filters */}
                            <PopupMenu
                                tooltip="select range"
                                className={classes.stealRoom}
                                items={quickFilters}
                                itemkey="key"
                                onSelect={onQuickFilter}
                                selection={quick}
                                title={quickTitle}
                                name="quick filters"/>
                        </Grid>
                        <Grid item className={classes.datePicker}>
                            <DateTimePicker
                                label="Start"
                                aria-label="start"
                                value={rangeStart}
                                onChange={handleStartChange}
                                inputFormat={theme.date.short}
                                disableMaskedInput={true}
                                maxDate={rangeEnd}
                                showTodayButton={true}
                                showToolbar={true}
                                ampm={false}/>
                        </Grid>
                        <Grid item className={classes.datePicker}>
                            <DateTimePicker
                                clearable={true}
                                ampm={false}
                                aria-label="end"
                                label="End"
                                value={rangeEnd}
                                onChange={handleEndChange}
                                inputFormat={theme.date.short}
                                disableMaskedInput={true}
                                minDate={rangeStart}
                                showTodayButton={true}
                                showToolbar={true}/>
                        </Grid>
                        <Grid item>
                            <IconButton
                                title="Hide Filter Panel"
                                onClick={toggleFilterbar}
                                aria-label="Hide Filter Panel"
                                size="large">
                                <ExpandLessIcon fontSize="inherit"/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Collapse>
    );
};

FilterBar.propTypes = {
    hideFilterbar: PropTypes.bool,
    gHideFilterbar: PropTypes.bool,
    hideTimelinebar: PropTypes.bool,
    handleSearchFilterChange: PropTypes.func,
    showFilterTimeout: PropTypes.object,
    filter: PropTypes.object,
    search: PropTypes.string,
    savedFilters: PropTypes.array,
    setShowFilter: PropTypes.func,
    showFilter: PropTypes.bool,
    fields: PropTypes.array,
    perms: PropTypes.object,
    handleSelectSavedFilter: PropTypes.func,
    handleUpsertSavedFilter: PropTypes.func,
    handleDeleteSavedFilter: PropTypes.func,
    handleOnFilterExport: PropTypes.func,
    handleOnFilterImport: PropTypes.func,
    backtesting: PropTypes.number,
    handleSetBacktesting: PropTypes.func,
    selectedBTJobs: PropTypes.array,
    handleSelectBTJobs: PropTypes.func,
    handleBacktestingJobsUpdated: PropTypes.func,
    english: PropTypes.string,
    toggleFilterbar: PropTypes.func,
    handleOnQuickFilter: PropTypes.func,
    quick: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
    handleStartChange: PropTypes.func,
    handleEndChange: PropTypes.func,
    label: PropTypes.string,
};

const MinDate = (a, b) => a.isBefore(b) ? a : b;
const MaxDate = (a, b) => a.isAfter(b) ? a : b;

const GetMomentRangeFromJobs = (selected, all) => {
    const selMap = (selected || []).reduce((a, c) => ({ ...a, [c]: true }), {});
    const starts = Object.values(all)
        .filter(j => selected.length === 0 || selMap[j.uuid])
        .filter(j => j.start > 0 && Moment.unix(j.start).isValid());
    const start = starts.reduce((a, c) => a ? MinDate(a, Moment.unix(c.start)) : Moment.unix(c.start), undefined) ||
        Moment().subtract(1, 'hour');

    const ends = Object.values(all)
        .filter(j => selected.length === 0 || selMap[j.uuid])
        .filter(j => j.end > 0 && Moment.unix(j.end).isValid());
    const end = ends.reduce((a, c) => MaxDate(a, Moment.unix(c.end)), start);
    return [start, end];
};

const GetMomentCreatedFromJobs = (selected, all) => {
    const selMap = (selected || []).reduce((a, c) => ({ ...a, [c]: true }), {});
    const starts = Object.values(all || {})
        .filter(j => selected.length === 0 || selMap[j.uuid])
        .filter(j => Moment(j.created).isValid());
    const start = starts.reduce((a, c) => a ? MinDate(a, Moment(c.created)) : Moment(c.created), undefined) ||
        Moment().subtract(1, 'hour');

    return start;
};

const GetRangeFromJobs = (selected, all) => {
    const range = GetMomentRangeFromJobs(selected, all);
    return [range[0].utc().toISOString(), range[1].utc().toISOString()];
};

const GetCreatedFromJobs = (selected, all) => {
    const start = GetMomentCreatedFromJobs(selected, all);
    return start.utc().toISOString();
};

const GetBacktestingEnglish = (selectedBTJobs, backtestingJobs) => {
    const btPre = (selectedBTJobs || []).length ? `Backtesting job${(selectedBTJobs || []).length > 1 ? 's are ' : ' is '}` : '';
    return btPre + (selectedBTJobs || [])
        .filter(j => backtestingJobs[j])
        .map(j => backtestingJobs[j].name)
        .join(', ');
};

export {
    FilterBar as default,
    GetRangeFromJobs,
    GetCreatedFromJobs,
    GetMomentRangeFromJobs,
    GetBacktestingEnglish,
    MaxDate,
    MinDate,
    QUICK_DAY,
    QUICK_HOUR,
    QUICK_WEEK,
    QUICK_JOB,
    BTMODE_BT,
    BTMODE_LIVE,
    BTMODE_NONE,
    QUICK_FILTERS,
};
